import { DoLogout } from "./authentication";
import { ReadObject } from "./storage";

export const API_ENDPOINT = process.env.REACT_APP_API_URL;
const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "";
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "";

export const GetHeaders = async (authenticated) => {
  const headers = { "Content-Type": "application/json" };
  const authentication = await ReadObject("authentication");
  if (authenticated && authentication.jwt) {
    headers.Authorization = `Bearer ${authentication.jwt}`;
  }
  return { headers };
};

export const ServerFetch = async (url, options, authenticated) => {
  const { headers } = await GetHeaders(authenticated);
  try {
    const response = await fetch(url, { ...options, headers });
    if ([403, 401].includes(response.status) && authenticated) {
      await DoLogout();
      window.location = "/login";
    }
    try {
      return await response.json();
    } catch (err) {
      return { error: true, message: response };
    }
  } catch (error) {
    return false;
  }
};

export const GET = async (path, authenticated = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: "GET",
    },
    authenticated
  );
};

export const POST = async (path, body, authenticated = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: "POST",
      body: JSON.stringify(body),
    },
    authenticated
  );
};

export const PUT = async (path, body, authenticated = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: "PUT",
      body: JSON.stringify(body),
    },
    authenticated
  );
};

export const DELETE = async (path, authenticated = false) => {
  return await ServerFetch(
    `${API_ENDPOINT}${path}`,
    {
      method: "DELETE",
    },
    authenticated
  );
};

export const ReadAddressesByZipCode = async (zipCode) => {
  try {
    let result = await fetch(`https://viacep.com.br/ws/${zipCode}/json/`);
    return result.json();
  } catch (err) {
    return false;
  }
};
export const PostImage = async (file, imageOptions) => {
  const uniqueUploadId = `uqid-${Date.now()}`;
  const chunkSize = 20 * 1024 * 1024;
  const totalChunks = Math.ceil(file.size / chunkSize);
  let currentChunk = 0;

  const uploadChunk = async (start, end) => {
    const formData = new FormData();
    formData.append("file", file.slice(start, end));
    formData.append("cloud_name", CLOUD_NAME);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("context", `displayName=${file.name}`);

    const contentRange = `bytes ${start}-${end - 1}/${file.size}`;

    if (imageOptions?.path) {
      formData.append("path", imageOptions.path);
    }

    if (imageOptions?.fileInfo) {
      formData.append("fileInfo", JSON.stringify(imageOptions.fileInfo));
    }

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`,
        {
          method: "POST",
          body: formData,
          headers: {
            "X-Unique-Upload-Id": uniqueUploadId,
            "Content-Range": contentRange,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Chunk upload failed.");
      }

      currentChunk++;

      if (currentChunk < totalChunks) {
        const nextStart = currentChunk * chunkSize;
        const nextEnd = Math.min(nextStart + chunkSize, file.size);
        return await uploadChunk(nextStart, nextEnd); // 🧠 importante: encadeamento
      } else {
        const finalResponse = await response.json();
        return finalResponse;
      }
    } catch (error) {
      console.error("Erro no chunk:", error);
      return { error: true, message: error.message };
    }
  };

  const start = 0;
  const end = Math.min(chunkSize, file.size);
  return await uploadChunk(start, end); // 👈 agora retorna o resultado completo
};

export const PrepareImageFile = (image) => {
  let btc = window.atob(image.source);
  let btn = new Array(btc.length);
  for (var i = 0; i < btc.length; i++) {
    btn[i] = btc.charCodeAt(i);
  }
  var bta = new Uint8Array(btn);
  let boobs = new Blob([bta], { type: "image/png" });
  return new File([boobs], `${image.filename}`);
};

export const UploadImage = (file, imageOptions) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = async () => {
      let source = `${reader.result}`.split(",")[1];
      let image = {
        filename: file.name,
        filetype: file.type,
        source,
      };
      let thefile = PrepareImageFile(image);
      let result = await PostImage(thefile, imageOptions);

      resolve(result);
    };
    reader.readAsDataURL(file);
  });
};

export const parseStrapiImage = (url) => {
  return !url
    ? ""
    : url.indexOf("://") !== -1
    ? url
    : `${API_ENDPOINT.replace("/api", "")}${url}`;
};
